import { defineMessages } from "react-intl";

export default defineMessages({
  additionalViews: {
    id: "Appointment.AppointmentPreviewCard.additionalViews",
    defaultMessage: "Additional views",
  },
});
